import Application from './Application';
import Popper from 'popper.js';

import "core-js/modules/es.array.includes";

//import './polyfill_io';


Popper.Defaults.modifiers.computeStyle.gpuAcceleration = !(window.devicePixelRatio < 1.5 && /Win/.test(navigator.platform));
Popper.Defaults.modifiers.preventOverflow = { enabled: false };
Popper.Defaults.modifiers.flip = { enabled: false };

$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
    icons: {
        time: 'material-icons material-icons-time',
        date: 'material-icons material-icons-date',
        up: 'material-icons material-icons-up',
        down: 'material-icons material-icons-down',
        previous: 'material-icons material-icons-previous',
        next: 'material-icons material-icons-next',
        today: 'material-icons material-icons-today',
        clear: 'material-icons material-icons-clear',
        close: 'material-icons material-icons-close'
    }
});


window.RegCustomWebApp = new Application(window);
window.RegCustomWebApp.Es8TranspilerTest();

